import React, { Context } from 'react';

const globalAlloyContextsKeyName = '__AlloyContexts__';

declare global {
  interface Window {
    [globalAlloyContextsKeyName]?: {
      [key: string]: Context<unknown>;
    };
  }
}

export const getOrCreateGlobalContext = <T>(name: string) => {
  const contexts = window[globalAlloyContextsKeyName] || {};
  if (!window[globalAlloyContextsKeyName]) {
    window[globalAlloyContextsKeyName] = contexts;
  }
  if (!contexts[name]) {
    contexts[name] = React.createContext<unknown>(undefined);
  }
  return contexts[name] as React.Context<T>;
};

export const getGlobalContext = (name: string) => {
  return window[globalAlloyContextsKeyName]?.[name];
};

export const CONTEXT_NAMES = {
  LocaleContext: 'LocaleContext',
  CompaniesContext: 'CompaniesContext',
  AlloyLaunchDarklyContext: 'AlloyLaunchDarklyContext',
  ProjectEntitlementsContext: 'ProjectEntitlementsContext',
  NotificationsContext: 'NotificationsContext',
  AccountEntitlementsContext: 'AccountEntitlementsContext',
  ProjectsContext: 'ProjectsContext',
  RolesContext: 'RolesContext',
  UserContext: 'UserContext',
  UsersContext: 'UsersContext',
  RelationshipsContext: 'RelationshipsContext',
  EntitiesCacheContext: 'EntitiesCacheContext',
  SideNavigationContext: 'SideNavigationContext',
  CurrentProjectIdContext: 'CurrentProjectIdContext',
  CurrentAccountIdContext: 'CurrentAccountIdContext',
  CurrentProductIdContext: 'CurrentProductIdContext',
  CurrentToolIdContext: 'CurrentToolIdContext',
  DatePickerContext: 'DatePickerContext',
} as const;
